// extracted by mini-css-extract-plugin
export var aligncenter = "sectionWithText-module--aligncenter--d61a2";
export var alignright = "sectionWithText-module--alignright--9bad2";
export var section = "sectionWithText-module--section--370ac";
export var sectionButton = "sectionWithText-module--section-button--87bed";
export var sectionLeft = "sectionWithText-module--section-left--d2c80";
export var sectionRight = "sectionWithText-module--section-right--7656b";
export var sectionText = "sectionWithText-module--section-text--5413a";
export var sectionWrap = "sectionWithText-module--section-wrap--fe0a2";
export var wpBlockJetpackGif = "sectionWithText-module--wp-block-jetpack-gif--496ae";
export var wpBlockJetpackGifWrapper = "sectionWithText-module--wp-block-jetpack-gif-wrapper--9f9b8";